import type { EntityName } from '../../../auth/Security';
import { SIDE_PANEL_ID_TO_LINKED_ENTITY_NODE_KEY_MAP } from '../../../deepLink/constants';

export type SidePanelDeepLinkMapping =
    | { mode: 'linkedNode'; nodeKey: string }
    | { mode: 'entityNode'; entity: EntityName };

export function resolveSidePanelSubjectBasePath(basePath: string, entityName?: EntityName): string {
    if (!entityName) return basePath;
    const entityKey = entityName.toLowerCase();
    const ancestors = basePath.split('.').filter((fragment) => fragment && fragment !== entityKey);
    const subjectBasePath = [...ancestors, entityKey].join('.');
    return subjectBasePath;
}

export function resolveSidePanelDeepLinkPath(
    basePath: string,
    panelId: string,
    deepLink?: SidePanelDeepLinkMapping
): string | undefined {
    if (!basePath) {
        return undefined;
    }

    const nodeKey =
        deepLink?.mode === 'linkedNode'
            ? deepLink.nodeKey
            : deepLink?.mode === 'entityNode'
              ? deepLink.entity.toLowerCase()
              : SIDE_PANEL_ID_TO_LINKED_ENTITY_NODE_KEY_MAP[panelId];

    return nodeKey ? `${basePath}.${nodeKey}` : undefined;
}
